import Account from "@/helper/AccountHelper.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import ConfigManager from '@/config/ConfigManager.js';
import { map } from 'rxjs/operators';

/**
 * @method apiRedeemCampaign
 */
export default {
    /**
     * @param {String|Number} campaignId
     * @param {Object} redeemParams
     * @param {String|Number} redeemQuantity
     */
    apiRedeemCampaign: function (campaignId, redeemParams, redeemQuantity) {
        let token = Account.getToken();
        var params = {...redeemParams};

        var url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/redeem`;
        if (!isNaN(redeemQuantity) && redeemQuantity > 1) {
            params.quantity = redeemQuantity;
            url = ConfigManager.getApiUrl() + `/campaign/${campaignId}/bulkredeem`;
        }
        return  BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
    apiRedeemUse: function (redeemKey) {
        let token = Account.getToken();
        var url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}/use`;
        return  BzbsApi.connectBzbsPost(url, token, null).pipe(map(res => res.data));
    },
    apiArrangeRedeem: function(redeemKey) {
        let token = Account.getToken();
        let url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}/arrange`;
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map(res => res.data));
    },
}
